module.exports = __webpack_public_path__ + "img/director-school-icon2.4e7bb4eb.jpg";